export * from 'server/models/LandingPage';


// WEBPACK FOOTER //
// ./data/models/LandingPage.ts